import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskAutomationRoute: InvariantJiraRoute = {
	name: 'project-settings-automation',
	path: '/jira/servicedesk/projects/:projectKey/settings/automate',
};
